import { FETCH_FAQ } from '../Components/actions/faqActions';

const initialState = {
  faqList: [],
};

const faqReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_FAQ:
      return {
        ...state,
        faqList: action.payload,
      };
    default:
      return state;
  }
};

export default faqReducer;
